// extracted by mini-css-extract-plugin
export default {"wrapper":"AppTab_wrapper__I8v1L","wrapper__tab":"AppTab_wrapper__tab__qhB4l","wrapper__activeTab":"AppTab_wrapper__activeTab__c4thK"};